<div class="info-card" fxLayout="column" fxLayoutGap="10px">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutGap="15px">
      @if (heading) {
        <div fxLayout="column" fxLayoutGap="5px">
          <span class="heading-default">{{heading}}</span>
          <span class="body-2-default">{{subHeading}}</span>
        </div>
      }

      @if (imageToDelete) {
        <app-confirm-remove message="Are you sure you want to remove this image from the lease?"
                            (confirmRemove)="emitDeleteImage()">
        </app-confirm-remove>
      }
    </div>

    @if (allowDownload && imageFiles.length > 0) {
      <div fxLayout="row">
        <button mat-icon-button color="primary" (click)="downloadImages()"
                [disabled]="isLoading"
                matTooltip="Download all items in showcase">
          <mat-icon>download</mat-icon>
        </button>
      </div>
    }

    @if (allowAdd) {
      <div fxLayout="row">
        <button mat-icon-button color="primary" (click)="addNewImage()"
                [disabled]="isLoading"
                matTooltip="Add new image">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    }
  </div>

  <div class="image-grid" fxLayout="row wrap" fxLayoutGap="16px grid">
    <div *ngFor="let image of imageFiles; let i = index" class="image-container">
      <img [src]="image.fileUrl" (click)="openImageCarousel(i)" alt="Showcase image">
      <button mat-icon-button class="menu-button" [matMenuTriggerFor]="menu" [disabled]="isLoading">
        <mat-icon>more_horiz</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="downloadImage(image)" [disabled]="isLoading">
          <mat-icon>download</mat-icon>
          <span>Download</span>
        </button>
        <button mat-menu-item (click)="triggerDeleteImage(image.documentId!)" [disabled]="!allowDelete || isLoading">
          <mat-icon>delete</mat-icon>
          <span>Remove</span>
        </button>
      </mat-menu>
    </div>

    @if (imageFiles.length == 0) {
      <div class="full-width" fxLayout="row" fxLayoutAlign="center center">
        <span *ngIf="!isLoading" class="heading-regular">There are no images included in this showcase.</span>
        <mat-spinner *ngIf="isLoading" [diameter]="30"></mat-spinner>
      </div>
    }
  </div>

  <div *ngIf="hasMoreImagesToLoad" class="load-more-container" fxLayout="row" fxLayoutAlign="center center">
    <button mat-button class="button-secondary" *ngIf="!isLoading" (click)="loadMoreImages.emit()">
      Load More
    </button>
    <mat-spinner *ngIf="isLoading" [diameter]="30"></mat-spinner>
  </div>
</div>
